

/**
 * @about ,  resource crud
 * 
 */

// react lib
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//side cmp
import SideNav from '../layout/SideNav';
//header cmp
import Header from '../layout/Header';
// bootstarp react
import { Dropdown, Modal } from 'react-bootstrap';
//for date
import dateFormat from "dateformat"
//redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// actions
import { addNewResource, getAllResourcesList } from "../../redux/actions/Resources";
import { getAllTags } from "../../redux/actions/Get";
import { getAllSiteList } from "../../redux/actions/Site";
import { getTagForFIlters } from "../../redux/actions/Tag";

// project action
import { getAllProjectList } from "../../redux/actions/Project";

// loader
import Loader from "../common/Loader";
// inline error
import InlineError from "../../components/common/InlineError";

// notify
import { notify } from "../../components/common/Toaster";
// add tag cmp
import AddTag from "../../components/common/add_tag/AddTag"
// copy to clip board lib
import { CopyToClipboard } from 'react-copy-to-clipboard';
// cmp project add
import AddProject from "../../components/common/add_project/AddProject";
// cmp project add
import AddSite from "../../components/common/add_site/AddSite";


// url & api services
import Url from "../../config/env/BaseUrl";
import { _Api } from "../../config/api/Api";



import {Rightarrow} from "../Svg";
var actionArr = []
class ResourceList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inviteNewPopupOpen: false,
            tagId: '',
            showDeleteModal: false,
            isLoadingState: false,
            dataCount: 10,
            searchString: '',
            statusSearch: '',
            sortType: '',
            sortField: '',
            pageNo: 0,
            totalpage: '',
            activeClass: 't',
            sortToggleName: true,
            sortToggleCreated: true,
            reportName: '',
            reportNameError: '',
            reportDescription: '',
            reportDescriptionError: '',
            reportUrl: '',
            reportFile: '',
            reportProjectId: '',
            reportSiteId: '',
            reportTagId: '',
            deletedId: '',
            reportUrlError: '',
            emptyFileError: '',
            statusState: 'Delete this resource',
            StatusAction: '',
            value: '',
            copied: false,
            FilterStatus: false,
            toggle: false,
            selectAll: false,
            fileUploadFileError: '',
            fileName: 'Choose file...',
            hideInput: '',
            sortTag: '',
            showTagName: 'All Tag',
            showTagColor: '#ffffff',
            dataShow: false,
        }
    }

    // didmount
    componentDidMount() {
        this.onClickPagenation();
        this.props.action.getAllTags({ status: "1" });
        this.props.action.getAllSiteList({ status: "1" });
        this.props.action.getAllProjectList({ status: "1" })
        this.props.action.getTagForFIlters({ tagType: 5, folder: this.props.match.params.id })
    }


    //handle on handleOnChange
    handleOnChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            reportNameError: '',
            reportDescriptionError: '',
            reportUrlError: '',
            emptyFileError: '',

        });
        setTimeout(() => {
            if (this.state.reportUrl != '')
                this.setState({ hideInput: 'file' })
            else if (this.state.fileName == 'Choose file...' && this.state.reportUrl == '')
                this.setState({ hideInput: '' })
        }, 300)
    }

    // open popup
    openInviteNewPopupOpen = () => {
        this.setState({
            inviteNewPopupOpen: !this.state.inviteNewPopupOpen
        })
    }

    //close modal
    closeModal = () => {
        this.setState({
            inviteNewPopupOpen: false,
        })
        this.clearFields()
    }

    // clear fields
    clearFields = () => {
        this.setState({
            reportName: '',
            reportNameError: '',
            reportDescription: '',
            reportDescriptionError: '',
            reportUrl: '',
            reportFile: '',
            reportProjectId: '',
            reportSiteId: '',
            reportTagId: '',
            deletedId: '',
            reportUrlError: '',
            fileUploadError: '',
            urlError: '',
            statusOk: false,
            emptyFileError: '',
            fileName: 'Choose file...',
            hideInput: '',
        })

    }

    // on image upload
    onImageUpload = e => {
        try {
            let file = e.target.files[0]
            this.setState({ hideInput: 'url', reportFile: file, fileName: file.name, fileUploadFileError: '' })
        } catch (err) {

        }
    }

    // on submit form
    handleOnSubmitForm = (e) => {
        const UrlRegx = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
        if (this.state.reportName == "") {
            this.setState({ reportNameError: "*Please enter resource name." })
        }
        else if (this.state.reportDescription == "") {
            this.setState({ reportDescriptionError: "*Please enter description.." })
        }



        else if (this.state.reportUrl != "" && !UrlRegx.test(this.state.reportUrl)) {
            this.setState({ reportUrlError: "*Please enter valid url." })
        }
        else if (this.state.reportUrl == "" && this.state.reportFile == '') {
            this.setState({ emptyFileError: "*Please enter url or add a file" })
        }



        else if (this.state.reportUrl == "" && !this.state.reportFile) {
            this.setState({ fileUploadFileError: "*Please add a file" })
        }

        else if (this.state.reportFile && this.state.reportFile.type.split("/")[0] != "text" && this.state.reportFile.type.split("/")[0] != "application") {


            this.setState({ fileUploadFileError: "*Please add a valid file.", })
        }
        else if (this.state.reportFile && this.state.reportFile.type.split("/")[1] == "exe" || this.state.reportFile.type == "application/x-ms-dos-executable" || this.state.reportFile.type == "application/x-iso9660-appimage") {


            this.setState({ fileUploadFileError: "*Please add a valid file.", })
        }
        else if (this.state.reportFile && this.state.reportFile.type.split("/")[1] == "zip" || this.state.reportFile.type == "application/x-ms-dos-executable" || this.state.reportFile.type == "application/x-iso9660-appimage" || this.state.reportFile.type == "application/x-ms-dos-executable" || this.state.reportFile.type == "application/vnd.android.package-archive") {

            this.setState({ fileUploadFileError: "*Please add a valid file.", })
        }
        else {
            let formData = new FormData()
            formData.append("resourceName", this.state.reportName);
            formData.append("desc", this.state.reportDescription)
            formData.append("folder", this.props.match.params.id)
            formData.append("url", this.state.reportUrl);
            formData.append("project", this.state.reportProjectId)
            formData.append("tag", this.state.reportTagId)
            formData.append("fileData", this.state.reportFile)
            formData.append("site", this.state.reportSiteId)


            let req2 = {
                folder: this.props.match.params.id,
                search: this.state.searchString,
                status: this.state.activeClass == "t" ? "" : this.state.activeClass == "a" ? "1" : "0",
                count: String(this.state.dataCount),
                sortType: this.state.sortType,
                sortField: this.state.sortField,
                pageNo: String(this.state.pageNo),
                tag: this.state.sortTag,
                tagType: 5,
            }


            if (e.target.name == "save") {

                this.props.action.addNewResource(formData, this.props.match.params.id, req2)
                this.closeModal()
                this.clearFields()

            }
            else {

                this.props.action.addNewResource(formData, this.props.match.params.id, req2)
                this.clearFields();
            }
        }
    }

    // handle delete modal
    // handle delete modal
    handleDeleteModal = (id, status) => {
        actionArr = [];
        this.setState({ statusState: status == 1 ? "Active this resource" : status == 0 ? "Inactive this resource" : "delete this resource" }, () => {

            this.setState({ showDeleteModal: !this.state.showDeleteModal })
            if (id) {
                this.setState({ deletTagId: id, StatusAction: status });
                actionArr.push(id)

            }
        }

        )
    }


    handleActionModal = () => {
        this.onUserAction(actionArr, this.state.StatusAction)
    }
    // on click yes to delete user handle , 
    // 1 for active
    // 0 for inactive
    // 2 for delete
    onUserAction = (actionArrr, statusCode) => {
        this.setState({ showDeleteModal: false, isLoadingState: true })
        let req = {
            status: statusCode,
            resourceId: [actionArrr].toString()
        }

        _Api(Url.ADMIN_CHANGE_STATUS_RESOURCE.method, Url.ADMIN_CHANGE_STATUS_RESOURCE.url, req )
            .then(resp => {
                this.setState({ isLoadingState: false, showDeleteModal: false, deletUserId: '', selectAll: false })
                actionArr = []

                notify("success", resp.responseData.message)
                this.onClickPagenation();


            }).catch(err => {
                this.setState({ isLoadingState: false, showDeleteModal: false, deletTagId: "", selectAll: false })
                actionArr = []

                if (err.error)
                    notify("err", err.error.message)
                else if (err)
                    notify("err", err.message)


            })
    }



    //edit user
    onClickEditUser = (resource) => {

        this.props.history.push(`/resources/edit/${this.props.match.params.id}/${resource._id}`, { state: resource });

    }



    // on click pagenation 
    // on search
    // 1 more
    onClickPagenation = (page) => {
        if (page == -1 && this.state.pageNo > 0) {
            this.setState({ pageNo: --this.state.pageNo })
        }
        if (page == 1 && (this.props.resourceData) >= this.state.pageNo)
            this.setState({ pageNo: ++this.state.pageNo })

        let req = {
            folder: this.props.match.params.id,
            search: this.state.searchString,
            status: this.state.activeClass == "t" ? "" : this.state.activeClass == "a" ? "1" : "0",
            count: String(this.state.dataCount),
            sortType: this.state.sortType,
            sortField: this.state.sortField,
            pageNo: String(this.state.pageNo),
            tag: this.state.sortTag,
            tagType: 5,
        }



        this.props.action.getAllResourcesList(req);
    }


    // on search
    handleOnSearch = (e) => {
        if (e.target.value.length >= 3)
            this.setState({ searchString: e.target.value, pageNo: 0 }, () => this.onClickPagenation())
        else if (e.target.value.length == "")
            this.setState({ searchString: e.target.value, pageNo: 0 }, () => this.onClickPagenation())
    }

    onChangeTabStstus = (tab) => {
        this.setState({ activeClass: tab, pageNo: 0 }, () => this.onClickPagenation())
    }


    // on click sort icons
    handleOnClickSort = (e) => {
        if (e == "report") {
            this.setState({ sortToggleName: !this.state.sortToggleName, sortType: this.state.sortToggleName ? '-1' : '1', sortField: 'resourceName' }, () => {

                this.onClickPagenation()
            })

        }

        else if (e == "createdAt") {
            this.setState({ sortToggleCreated: !this.state.sortToggleCreated, sortType: this.state.sortToggleCreated ? '1' : '-1', sortField: 'created' }, () => {

                this.onClickPagenation()
            })

        }

    }

    handleAddTag = (e) => {
        if (e.target.name == "site")
            this.clickChild5()
        else if (e.target.name == "tag")
            this.clickChild()
        else if (e.target.name == "project")
            this.clickChild3()
        this.setState({ inviteNewPopupOpen: false })

    }

    // on checked
    handleChecked = (e) => {
        let num = e.target.value
        if (actionArr.indexOf(num) == -1) {
            actionArr.push(num)
            this.setState({ toggle: !this.state.toggle })
        }
        else {
            let arr =
                actionArr = actionArr.filter(item => item != num)
            this.setState({ toggle: !this.state.toggle })
        }
    }

    // after select multiple check box
    handleDeleteModal2 = (id, status) => {
        if (actionArr.length == 0) return
        this.setState({ StatusAction: status, statusState: status == 1 ? "Active these resources" : status == 0 ? "Inactive these resources" : "delete these resources" }, () => {
            this.setState({ showDeleteModal: !this.state.showDeleteModal })
        })
    }


    handleAllSelect = () => {
        try {
            if (!this.state.selectAll) {
                actionArr = []
                this.props.resourceList &&
                    this.props.resourceList.forEach(item => actionArr.push(item._id))
                this.setState({ selectAll: true })
            }
            else {
                actionArr = []
                this.setState({ selectAll: false })
            }
        } catch (err) { }
    }

    // sort by tag data
    sortByTag = (item) => {
        this.setState({
            sortTag: item._id,
            showTagName: item.tagName,
            showTagColor: item.color
        }, () => this.onClickPagenation())

    }

    render() {
        let pageRange = Math.ceil(this.props.resourceData / this.state.dataCount)
        setTimeout(() => this.setState({ dataShow: true }), 4000)
        return (
            <>
                {this.props.isLoading && <Loader /> || this.state.isLoadingState && <Loader />}
                <SideNav />
                <div className="main-body">
                    <Header
                        isSearch={true}
                        onClickSearchTest={(e) => this.handleOnSearch(e)}
                    />
                    <div className="body_header folder">
                        <h6 className="headingH6"> <Link to="/resources/folders">Resources</Link> &nbsp;
                        <span className="cm_arrow"><Rightarrow/></span>
                        &nbsp; {this.props.location.state && this.props.location.state.state}</h6>
                        <div className="new_btn text-right">
                            <button className="btn btn-primary btn-blue" onClick={this.openInviteNewPopupOpen}>Add New</button>
                        </div>
                    </div>
                    <div className="counter_detail">
                        <div className={`counter_parent ${this.state.activeClass == 'a' ? 'active' : ''} `} onClick={() => this.onChangeTabStstus("a")}>
                            <h4>ACTIVE</h4>
                            <h4>{this.props.resourceActive && this.props.resourceActive}</h4>
                        </div>
                        <div className={`counter_parent ${this.state.activeClass == 'i' ? 'active' : ''} `} onClick={() => this.onChangeTabStstus("i")}>
                            <h4>INACTIVE</h4>
                            <h4 className="yellow">{this.props.resourceInactive && this.props.resourceInactive}</h4>
                        </div>

                        <div className={`counter_parent ${this.state.activeClass == 't' ? 'active' : ''} `} onClick={() => this.onChangeTabStstus("t")}>
                            <h4>TOTAL</h4>
                            <h4 className="green">{this.props.resourceTotal && this.props.resourceTotal}</h4>
                        </div>
                        <Dropdown className="filter_dropdown" alignRight>
                            <Dropdown.Toggle className="ext-css" variant="success" id="dropdown-basic"   >
                                <>

                                    <div style={{ backgroundColor: this.state.showTagColor }} className="filter_dropdown_option"></div>
                                    &nbsp;&nbsp;
                                <div className="tagText">{this.state.showTagName}</div>
                                </>

                            </Dropdown.Toggle>

                            <Dropdown.Menu className="action_menu" alignRight>
                                <>
                                    <Dropdown.Item onSelect={() => this.sortByTag({ _id: '', tagName: 'All Tag', color: '#ffffff' })}  >
                                        <div className="filter_dropdown_parent" >
                                            &nbsp;&nbsp;
                                                <div>All Tag
                                                </div>
                                        </div>

                                    </Dropdown.Item>

                                </>
                                {
                                    this.props.filterTagData && this.props.filterTagData.map((item, index) => (
                                        <>
                                            <Dropdown.Item  >
                                                <div className="filter_dropdown_parent" onClick={() => this.sortByTag(item)}>

                                                    <div style={{ backgroundColor: item.color }} className="filter_dropdown_option"></div>
                                                    &nbsp;&nbsp; <div>{item.tagName}</div>
                                                </div>

                                            </Dropdown.Item>

                                        </>

                                    ))
                                }

                            </Dropdown.Menu>
                        </Dropdown>

                    </div>

                    <hr />
                    {
                        actionArr && actionArr.length != 0 &&

                        <Dropdown>
                            <Dropdown.Toggle variant="success" id="dropdown-basic" className="action_dropdown">
                                {actionArr.length} Select
                          </Dropdown.Toggle>

                            <Dropdown.Menu className="action_menu">
                                <Dropdown.Item onSelect={() => this.handleDeleteModal2(actionArr, "1")}>Active</Dropdown.Item>
                                <Dropdown.Item onSelect={() => this.handleDeleteModal2(actionArr, "0")}>Inactive</Dropdown.Item>
                                <Dropdown.Item onSelect={() => this.handleDeleteModal2(actionArr, "2")}>Delete</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                    <div className="table-responsive">
                        <table className="table table-condensed">
                            <thead>
                                <tr>
                                    <th> <input type="checkbox" className="checkbox" name="time" value={"test"} checked={this.state.selectAll} onClick={this.handleAllSelect} /></th>
                                    <th>Sr No.</th>
                                    <th onClick={() => this.handleOnClickSort("report")}>Resource Name<span className="sort_icon"><i className={`fa fa-sort-alpha-${this.state.sortToggleName ? "asc" : "desc"}`} aria-hidden="true"></i></span></th>
                                    <th>Created By </th>
                                    <th>Type</th>
                                    <th onClick={() => this.handleOnClickSort("createdAt")} >Created At <span className="sort_icon"><i class={`fa fa-sort-numeric-${this.state.sortToggleCreated ? "asc" : "desc"}`} aria-hidden="true"></i></span></th>
                                    <th>Tag</th>
                                    <th>Action</th>
                                    <th>Status</th>

                                </tr>
                            </thead>
                            <tbody>

                                {

                                    this.props.resourceList &&
                                    this.props.resourceList.map((resource, index) => (
                                        <tr key={index}>
                                            <td><input type="checkbox" className="checkbox" name="time" value={resource._id} checked={actionArr.indexOf(resource._id) != -1} onClick={this.handleChecked} /></td>
                                            <td>{index + 1 + this.state.pageNo * this.state.dataCount}</td>
                                            <td className="txtClassUpper">{`${resource.resourceName}`}</td>                                            
                                            <td>{"Admin"}</td>
                                            <td>{resource.fileType}</td>
                                            <td>{dateFormat(resource.created, "mm/dd/yyyy")}</td>
                                            <td>
                                                {
                                                    resource.tagName == undefined ?
                                                        <>
                                                            <i class="fa fa-window-minimize" aria-hidden="true">
                                                            </i>
                                                            &nbsp;
                                                                                <i class="fa fa-window-minimize" aria-hidden="true">
                                                            </i>
                                                            &nbsp;
                                                                                <i class="fa fa-window-minimize" aria-hidden="true">
                                                            </i>
                                                        </>
                                                        :
                                                        <div class="display-flex">
                                                            <div style={{ backgroundColor: resource.color }} class="color_circle"></div>
                                                            &nbsp;&nbsp;
                                                                                <div>{resource.tagName}</div>
                                                        </div>
                                                }
                                            </td>
                                            <td>
                                                <div>
                                                    <button type="button" className="btn btn-primary btn-sm btn-blue" onClick={() => this.onClickEditUser(resource)}>Edit</button>&nbsp;&nbsp;&nbsp;
                                                    <button type="button" className="btn btn-primary btn-sm btn-pink" onClick={() => this.handleDeleteModal(resource._id, "2")}>Delete</button> &nbsp;&nbsp;&nbsp;


                                                  {
                                                        resource.fileType == "url" ? <CopyToClipboard text={resource.fileData}
                                                            onCopy={() => notify("success", "copied")}>
                                                            <button className="btn  btn-sm btn-default"   >Copy</button>
                                                        </CopyToClipboard> :
                                                            <a href={resource.fileData} className="btn  btn-sm btn-default" download="renamed.txt" >Export</a>
                                                    }


                                                </div>
                                            </td>
                                            <td>
                                                <button type="button" onClick={() => this.handleDeleteModal(resource._id, resource.status == "1" ? "0" : "1")} class={`btn btn-toggle ${resource.status == "1" ? "active" : ""}`} data-toggle="button" aria-pressed="true" autocomplete="off">
                                                    <div class="handle"></div>
                                                </button>
                                            </td>


                                        </tr>
                                    ))
                                }

                            </tbody>
                        </table>
                        {
                            this.state.dataShow && this.props.resourceData == 0 && this.props.isLoading != true && <p className="cm_center_text" > Sorry no more content </p>
                        }



                        <div className="float-right">
                            {this.props.resourceData >= 10 &&
                                <div class="pagination">
                                    <button class="page-item" onClick={() => this.onClickPagenation(-1)} disabled={this.state.pageNo == 0} ><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
                                    <p>{this.state.pageNo + 1} to {pageRange == 0 ? 1 : pageRange}</p>
                                    <button class="page-item" onClick={() => this.onClickPagenation(1)} disabled={Math.ceil(this.props.resourceData / this.state.dataCount) <= this.state.pageNo + 1} ><i class="fa fa-chevron-right" aria-hidden="true" ></i></button>

                                </div>

                            }
                        </div>
                    </div>
                </div>

                <AddTag
                    setClick={click => this.clickChild = click}
                    closeModalAddTag={() => this.setState({ inviteNewPopupOpen: true })}
                />
                <AddSite
                    setClick={click => this.clickChild5 = click}
                    closeModalAddTag={() => this.setState({ inviteNewPopupOpen: true })}

                />
                <AddProject
                    setClick={click => this.clickChild3 = click}
                    closeModalAddTag={() => this.setState({ inviteNewPopupOpen: true })}

                />


                <Modal show={this.state.inviteNewPopupOpen} onHide={this.closeModal} className="custom_modal" centered>

                    <Modal.Header closeButton>
                        <h6>Add New</h6>
                    </Modal.Header>

                    <Modal.Body>
                        <form onSubmit={this.handleOnSubmitForm}>


                            <div class="form-group">
                                <label for="email">Resource Name</label><span className="impFields">*</span>
                                <input
                                    type="text"
                                    className={`form-control ${this.state.reportNameError != '' ? 'is-invalid' : ''}`}
                                    id="reportName"
                                    name="reportName"
                                    placeholder="Enter resource Name"
                                    maxLength={30}
                                    value={this.state.reportName}
                                    autocomplete="off"
                                    onChange={this.handleOnChange}
                                    required

                                />
                                <InlineError
                                    message={this.state.reportNameError}
                                />
                            </div>


                            <div class="form-group">
                                <label for="email">Description</label><span className="impFields">*</span>
                                <textarea rows="4" cols="50"
                                    type="text"
                                    className={`form-control ${this.state.reportDescriptionError != '' ? 'is-invalid' : ''}`}
                                    id="reportDescription"
                                    placeholder="Enter description"
                                    maxLength={256}
                                    name="reportDescription"
                                    autocomplete="off"
                                    required
                                    value={this.state.reportDescription}
                                    onChange={this.handleOnChange}

                                />
                                <InlineError
                                    message={this.state.reportDescriptionError}
                                />
                            </div>


                            <div class="form-group row df-end">
                                <div className="col-md-8">
                                    <label for="email">URL</label><span className="impFields">*</span><br />
                                    <input
                                        disabled={this.state.hideInput == "url"}
                                        type="url"
                                        className={`form-control ${this.state.reportUrlError != '' ? 'is-invalid' : ''}`}
                                        id="reportUrl"
                                        placeholder="Enter url"
                                        maxLength={256}
                                        name="reportUrl"
                                        autocomplete="off"
                                        required
                                        value={this.state.reportUrl}
                                        onChange={this.handleOnChange}

                                    />
                                    <InlineError
                                        message={this.state.reportUrlError}
                                    />

                                </div>
                            </div>



                            <div class="form-group row df-end">
                                <div className="col-md-12">
                                    <InlineError
                                        message={this.state.emptyFileError}
                                    />
                                    <label className="text-center display-b" style={{ height: 'auto' }}>OR</label>
                                    <label for="email">Resource file</label><span className="impFields">*</span><br />
                                    <div class="custom-file">
                                        <input disabled={this.state.hideInput == "file"} id="inputGroupFile01" onChange={this.onImageUpload} type="file" className={`custom-file-input  ${this.state.fileUploadFileError != '' ? 'is-invalid' : ''}`}

                                            accept=".xlsx,.xls, .doc, .docx,.ppt, .pptx,.txt,.pdf"
                                        />
                                        <label class="custom-file-label" for="inputGroupFile01">{this.state.fileName}</label>
                                    </div>

                                    <InlineError
                                        message={this.state.fileUploadFileError}
                                    />

                                </div>
                            </div>

                            <div>
                                <div class="form-group row df-end">
                                    <div className="col-md-8">
                                        <label for="email">Project</label>
                                        <select class="form-control" id="sel1" name="reportProjectId" onChange={this.handleOnChange}>
                                            {this.state.reportProjectId == "" && <option key={-1} value={"select"} disabled selected hidden  >{"Select project"}</option>}
                                            {
                                                this.props.projectInfo && this.props.projectInfo.map((item, index) =>
                                                    (
                                                        <option key={index} value={item._id}>{`${item.projectName}`}</option>
                                                    )
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-4"><button type="button" class="btn btn-primary btn-blue P1016 col-sm-12" name="project" onClick={this.handleAddTag} >Add Project</button></div>

                                </div>

                                <div class="form-group row df-end">
                                    <div className="col-md-8">
                                        <label for="email">Sites</label>
                                        <select class="form-control" id="sel1" name="reportSiteId" onChange={this.handleOnChange}>
                                            {this.state.reportSiteId == "" && <option key={-1} value={"select"} disabled selected hidden  >{"Select site"}</option>}
                                            {
                                                this.props.siteInfo && this.props.siteInfo.map((item, index) =>
                                                    (
                                                        <option key={index} value={item._id}>{item.siteName}</option>
                                                    )
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-4"><button type="button" class="btn btn-primary btn-blue P1016 col-sm-12" name="site" onClick={this.handleAddTag} >Add Sites</button></div>

                                </div>


                                <div class="form-group row df-end">
                                    <div className="col-md-8">
                                        <label for="email">Tag</label>
                                        <select class="form-control" id="sel1" name="reportTagId" onChange={this.handleOnChange}>
                                            {this.state.reportTagId == "" && <option key={-1} value={"select"} disabled selected hidden  >{"Select tag"}</option>}
                                            {
                                                this.props.tagsList && this.props.tagsList.map((item, index) =>
                                                    (
                                                        <option className="txtClassUpper" key={index} value={item._id}>{item.tagName}</option>
                                                    )
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-4"><button type="button" class="btn btn-primary btn-blue P1016 col-sm-12" name="tag" onClick={this.handleAddTag}>Add Tag</button></div>

                                </div>
                                <br />
                                <div class="form-group">
                                    <button type="button" class="btn btn-default mR-20" onClick={this.handleOnSubmitForm}>Save & Add New</button>
                                    <button type="button" name="save" class="btn btn-primary btn-blue " onClick={this.handleOnSubmitForm}>Save</button>
                                </div>
                            </div>

                        </form>
                    </Modal.Body>

                </Modal>

                <Modal show={this.state.showDeleteModal} onHide={this.handleDeleteModal} className="custom_modal">
                    <Modal.Header closeButton>
                        <h6>Resource Action</h6>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want {this.state.statusState} ? </Modal.Body>
                    <Modal.Footer>
                        <button class="btn btn-default  btn-sm mR-20" onClick={this.handleDeleteModal}>
                            No
          </button>
                        <button variant="primary" class="btn btn-primary btn-sm btn-blue " onClick={this.handleActionModal}>
                            Yes
          </button>
                    </Modal.Footer>
                </Modal>

            </>
        );

    }
}

// get store data
const mapStateToProps = state => {
    return {
        isLoading: state.loading.isLoading,
        isLoggedIn: state.login.isLoggedIn,
        tagsList: state.tags.tagInfo,
        siteInfo: state.sites.siteInfo,
        resourceList: state.resources.resourceInfo,
        resourceActive: state.resources.activeresource,
        resourceInactive: state.resources.inactiveResource,
        filterTagData: state.tags.filterInfo,
        resourceTotal: state.resources.totalResource,
        resourceData: state.resources.dataCount,
        projectInfo: state.projects.projectInfo,
    }
}

// dispatch action
const mapDispatchToProps = dispatch => {
    return {
        action: bindActionCreators({ getTagForFIlters, getAllProjectList, getAllTags, addNewResource, getAllResourcesList, getAllSiteList }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceList);

